import getConfig from 'next/config';
import { useContext, useEffect, useState } from 'react';
import RootContext from '../../../util/root.context';
import { clearAllCookies } from '../../hooks/useCookie';
import { clearLocalStorage } from '../../hooks/useLocalStorage';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import errorTrack from '../../../util/Genesys';

const { publicRuntimeConfig } = getConfig();
const EirPrepayModal = ({
  enableWebChat,
  setEnableModal,
  errorModal,
  setShowLoader,
  setOnLoadingDisablecta,
}) => {
  const { dispatch } = useContext(RootContext);
  const [cmsCollectionData, setCmsCollectionData] = useState({});

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'Prepay_Customer_Modal',
      });
      setCmsCollectionData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  const clearCurrentJourney = () => {
    clearLocalStorage();
    clearAllCookies();
    setEnableModal(false);
    enableWebChat.disable();
    errorModal.disable();
    setOnLoadingDisablecta(false);
    setShowLoader(false);
    dispatch({ type: 'ENABLE_LOGOUT', payload: false });
  };
  const handleChatNow = modalId => {
    errorTrack(modalId);
  };
  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={enableWebChat.value}
      handleClose={enableWebChat.disable}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
    ${
      cmsCollectionData?.attributes?.secondHalfDescription
        ? cmsCollectionData?.attributes?.secondHalfDescription
        : ''
    }
    `}
      cta={[
        {
          // text: 'Shop now',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Shop now',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => clearCurrentJourney(),
        },
        {
          // text: 'Chat now',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Chat now',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => handleChatNow(cmsCollectionData?.attributes?.modalID),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
    />
  );
};
export default EirPrepayModal;
